"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Types = exports.Sizes = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _excluded = ["children", "functional", "primary"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * // TODO: изменить использование на проектах на ButtonTs
 * @see https://leveltravel.atlassian.net/browse/LT-23586
 */
var Sizes = exports.Sizes = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny',
  NONE: 'none'
};
var Types = exports.Types = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit'
};
var SIZES = {
  FLEX: 'flex',
  LARGE: 'large',
  NORMAL: 'normal',
  TINY: 'tiny',
  NONE: 'none'
};
var TYPES = {
  BUTTON: 'button',
  RESET: 'reset',
  SUBMIT: 'submit'
};

/**
 * @deprecated используй ButtonTs
 */
var Button = /*#__PURE__*/function (_React$PureComponent) {
  function Button() {
    (0, _classCallCheck2["default"])(this, Button);
    return _callSuper(this, Button, arguments);
  }
  (0, _inherits2["default"])(Button, _React$PureComponent);
  return (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        isFunctional = _this$props.functional,
        isPrimary = _this$props.primary,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var button;
      if (isFunctional) {
        button = /*#__PURE__*/_react["default"].createElement(StyledFunctionalButton, null);
      } else if (isPrimary) {
        button = /*#__PURE__*/_react["default"].createElement(StyledPrimaryButton, null);
      } else {
        button = /*#__PURE__*/_react["default"].createElement(StyledButton, null);
      }
      return /*#__PURE__*/_react["default"].cloneElement(button, props, children);
    }
  }]);
}(_react["default"].PureComponent);
Button.propTypes = {
  autoFocus: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  functional: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  primary: _propTypes["default"].bool,
  bgColor: _propTypes["default"].string,
  size: _propTypes["default"].oneOf(Object.values(SIZES)),
  type: _propTypes["default"].oneOf(Object.values(TYPES))
};
Button.defaultProps = {
  autoFocus: false,
  children: null,
  className: '',
  disabled: false,
  functional: false,
  onClick: Function.prototype,
  primary: false,
  bgColor: 'var(--background)',
  size: SIZES.NORMAL,
  type: TYPES.BUTTON
};
Button.Sizes = SIZES;
Button.Types = TYPES;
var BasePropsStyle = _styledComponents["default"].button.withConfig({
  displayName: "Button__BasePropsStyle",
  componentId: "sc-2l34wi-0"
})(["&{cursor:pointer;font-family:inherit;", "}"], function (props) {
  return props.disabled && (0, _styledComponents.css)(["cursor:default;user-select:none;"]);
});
var BaseStyle = (0, _styledComponents["default"])(BasePropsStyle).withConfig({
  displayName: "Button__BaseStyle",
  componentId: "sc-2l34wi-1"
})(["&:focus{outline:none;}", " ", " ", " ", " ", " ", ""], function (props) {
  return props.size !== SIZES.NONE && props.size !== SIZES.FLEX && (0, _styledComponents.css)(["overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"]);
}, function (props) {
  return (props.size === SIZES.FLEX || props.size === SIZES.NORMAL) && (0, _styledComponents.css)(["line-height:16px;padding-bottom:7px;padding-top:7px;"]);
}, function (props) {
  return props.size === SIZES.FLEX && (0, _styledComponents.css)(["min-height:43px;width:initial;"]);
}, function (props) {
  return props.size === SIZES.LARGE && (0, _styledComponents.css)(["height:48px;width:150px;"]);
}, function (props) {
  return props.size === SIZES.NORMAL && (0, _styledComponents.css)(["height:43px;width:150px;"]);
}, function (props) {
  return props.size === SIZES.TINY && (0, _styledComponents.css)(["height:34px;max-width:150px;"]);
});
var StyledButton = (0, _styledComponents["default"])(BaseStyle).withConfig({
  displayName: "Button__StyledButton",
  componentId: "sc-2l34wi-2"
})(["--background-color:", ";border:none;background-color:var(--background-color);border-radius:var(--border-radius);color:var(--black);", " ", ""], function (props) {
  return props.bgColor;
}, function (props) {
  return !(props.disabled || props.offHover) && (0, _styledComponents.css)([":hover{background:linear-gradient(0deg,rgba(0,0,0,var(--hover-alpha)) 0%,rgba(0,0,0,var(--hover-alpha)) 100%),var(--background-color);}:active{background:linear-gradient(0deg,rgba(0,0,0,var(--pressed-alpha)) 0%,rgba(0,0,0,var(--pressed-alpha)) 100%),var(--background-color);}"]);
}, function (props) {
  return props.disabled && (0, _styledComponents.css)(["opacity:var(--disabled-opacity);"]);
});
var StyledPrimaryButton = (0, _styledComponents["default"])(BaseStyle).withConfig({
  displayName: "Button__StyledPrimaryButton",
  componentId: "sc-2l34wi-3"
})(["", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.elements.button.primary;
}, function (props) {
  return props.offHover && (0, _styledComponents.css)(["&,&:hover{box-shadow:var(--box-shadow);}"]);
});
var StyledFunctionalButton = (0, _styledComponents["default"])(BasePropsStyle).withConfig({
  displayName: "Button__StyledFunctionalButton",
  componentId: "sc-2l34wi-4"
})(["appearance:none;border:none;"]);
var _default = exports["default"] = Button;